export default class Constants {
  static COOKIE_NAME_CLIENT_ID = "_cdp_ci"
  static COOKIE_NAME_SESSION_ID = "_cdp_si"
  static COOKIE_NAME_CAMPAIGN_EXPOSURE_LIST = "_cdp_campaignExposureList"
  static COOKIE_NAME_CAMPAIGN_TODAY_NONE_EXPOSURE_LIST = "_cdp_campaignTodayNoneExposureList"
  static STORAGE_KEY_CAMPAIGN_INFLOW_LIST = "_cdp_campaignInflowList"
  static BASE_API_URL = (() => {
    if (location.port === '63342') {
      return 'http://localhost:9000'
    }
    if (location.host.includes('localhost')) {
      return 'http://localhost:9000'
    }
    if (location.host.includes('dev.ktovisitkorea.com')) {
      return 'https://es-cdp.ktovisitkorea.com'
    }
    return 'https://cdp.visitkorea.or.kr'
  })()
}
